import React, { useState, useEffect, useReducer, useMemo } from "react";
import SelectBox from "devextreme-react/select-box";
import { Button, TextBox } from "devextreme-react";

import { Validator, RequiredRule } from "devextreme-react/validator";
import { Accordion, Item as AccordionItem } from "devextreme-react/accordion";
import { v4 as uuidv4 } from "uuid";
import * as actions from "../../../actions/multiSurvey";
import multiSurveyReducer from "../../../reducers/multiSurvey";
import { alert } from "devextreme/ui/dialog";
import { DateBox, ScrollView, NumberBox } from "devextreme-react";
import moment from "moment";
import { sortBy } from "lodash";
import { Popup, Position } from "devextreme-react/popup";
import { ButtonGroup } from "devextreme-react/button-group";
import notify from "devextreme/ui/notify";
import _ from "lodash";
import { postUserLog } from "../../../actions/common";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import "./multisuvertabs.css";

const initialState = {
  surveyDailyQuestionDetails: null,
  refreshMultiSurveyWidget: null,
};

const MultiSurveyDailyInput = (props: any) => {
  const [state, dispatch] = useReducer(multiSurveyReducer, initialState);
  let { surveyDailyQuestionDetails, refreshMultiSurveyWidget } = state;
  let {
    siteId,
    setsurveyEditPopUpMgr,
    open,
    close,
    tierId,
    isRefreshDataRequired,
    setIsRefreshDataRequired,
    siteLocalDate,
    surveyShiftDetails,
    surveyID,
    surveyName,
    setSiteLocalDate,
  } = props;
  const [selectedShift, setSelectedShift] = useState<any>(null);
  let [multiSurveyDate, setMultiSurveyDate] = useState<any>(siteLocalDate);
  const [inputMinDate, setInputMinDate] = useState<any>(multiSurveyDate);
  const [surveyIDVal, setSurveyIDVal] = useState<number>(surveyID);
  const [surveyNameVal, setSurveyNameVal] = useState<any>(surveyName);
  const [tabArray, settabArray] = useState<any>([]);
  const [isCurrentDate, setIsCurrentDate] = useState<any>(true);
  const [showPopUp, setshowPopUp] = useState(true);
  const [Questionare, setQuestionare] = useState<any>([]);
  const [initialQuestionare, setInitialQuestionare] = useState<any>([]);
  const [surveyTarget, setsurveyTarget] = useState<any>("");

  const yesOrNo = [
    {
      icon: "check",
      alignment: true,
      hint: "Yes",
      color: "Green",
    },
    {
      icon: "close",
      alignment: false,
      hint: "No",
      color: "Red",
    },
  ];
  const handleIsCurrentDate = (multiSurveyDate: any) => {
    let currentDate = moment(inputMinDate).format("YYYY-MM-DD");
    if (currentDate === multiSurveyDate) {
      setIsCurrentDate(true);
    } else {
      setIsCurrentDate(false);
    }
  };
  useEffect(() => {
    // Calculate the percentage and color for initial load
    if (surveyShiftDetails !== null && surveyIDVal > 0) {
      setSelectedShift(surveyShiftDetails[0]?.shiftScheduleId);
    }
  }, [surveyIDVal, surveyShiftDetails]);

  useEffect(() => {
    if (selectedShift > 0) {
      let inputSurveyData = {
        surveyID: +surveyIDVal || 0,
        tierID: +tierId,
        shiftScheduleID: selectedShift,
        surveyDate: moment(multiSurveyDate).format("YYYY-MM-DD"),
        //shift: shiftNo,
      };
      handleIsCurrentDate(moment(multiSurveyDate).format("YYYY-MM-DD"));

      actions.fetchShiftSurveyQuestionData(dispatch, inputSurveyData);
    }
  }, [multiSurveyDate, selectedShift]);

  useEffect(() => {
    if (refreshMultiSurveyWidget) {
      close(false);
      setIsRefreshDataRequired(!isRefreshDataRequired);
    }
    postUserLog({
      event: "Survey Input Screen Launch",
      data: {
        action: "Survey Input Launched",
        module: "Digital Tier",
        section: props.navigationOn,
        siteUId: siteId,
        widget: "Survey App",
        tierId: tierId,
      },
    });
  }, [refreshMultiSurveyWidget]);

  useEffect(() => {
    if (surveyDailyQuestionDetails !== null) {
      setInitialQuestionare(transformingData(surveyDailyQuestionDetails));
      setQuestionare(transformingData(surveyDailyQuestionDetails));
      setsurveyTarget(surveyDailyQuestionDetails[0]?.target);
    }
  }, [surveyDailyQuestionDetails]);

  const [newTabArrayColor, setnewTabArrayColor] = useState<any>([]);

  useEffect(() => {
    const updatedNewTabArray = [];
    for (let i = 1; i <= Math.ceil(Questionare.length / 3); i++) {
      const tabGroup = Questionare?.slice((i - 1) * 3, i * 3);
      const color = getCategoryColor(tabGroup);
      const categoryInfo = {
        index: i,
        Color: color,
      };
      updatedNewTabArray.push(categoryInfo);
    }

    setnewTabArrayColor(updatedNewTabArray);
  }, [Questionare]);

  const getCategoryColor = (tabGroup: any) => {
    for (const item of tabGroup) {
      for (const tableItem of item.tableval) {
        if (tableItem.isYes === null) {
          return "#2a2a2ad9";
        }
      }
    }
    return "#349502d9";
  };

  function transformingData(data: any) {
    const transformedData: any = {};

    data.forEach((item: any) => {
      if (!transformedData[item.categoryID]) {
        transformedData[item.categoryID] = {
          categoryID: item.categoryID,
          category: item.category,
          tableval: [],
        };
      }
      transformedData[item.categoryID].tableval.push({
        questionID: item.questionID,
        question: item.question,
        weightage: item.weightage,
        isYes: item.isYes,
        comments: item.comments,
      });
    });
    const dataObject: any = Object.values(transformedData);
    let newTabArray: any = [];
    if (dataObject.length < 3) {
      newTabArray = [1];
    } else {
      for (let i = 1; i <= Math.ceil(dataObject.length / 3); i++) {
        newTabArray.push(i);
      }
    }

    settabArray(newTabArray);

    return Object.values(transformedData);
  }

  const customHeader = (item: any) => {
    return <div className="questionheader"> {item.category}</div>;
  };

  const onQuestionChange = (v: any, questions: any, item: any) => {
    const updatedItems = [...Questionare];

    for (let i = 0; i < updatedItems.length; i++) {
      if (updatedItems[i].categoryID === item.categoryID) {
        for (let j = 0; j < updatedItems[i].tableval.length; j++) {
          if (updatedItems[i].tableval[j].questionID === questions.questionID) {
            updatedItems[i].tableval[j].comments = v.value;
          }
        }
      }
    }
    setQuestionare(updatedItems);
  };

  const onIsYesChange = (v: any, questions: any, item: any) => {
    const updatedItems = [...Questionare];
    v.component._customClass = "bgGreen";
    for (let i = 0; i < updatedItems.length; i++) {
      if (updatedItems[i].categoryID === item.categoryID) {
        for (let j = 0; j < updatedItems[i].tableval.length; j++) {
          if (updatedItems[i].tableval[j].questionID === questions.questionID) {
            updatedItems[i].tableval[j].isYes = v.itemData.alignment;
          }
        }
      }
    }
    setQuestionare(updatedItems);
  };
  const saveClick = () => {
    const saveDataConversion: any = [];

    Questionare.forEach((categories: any) => {
      const { tableval } = categories;

      tableval.forEach((questions: any) => {
        const { questionID, isYes, comments } = questions;

        saveDataConversion.push({
          questionID,
          isYes,
          comments,
        });
      });
    });

    for (const item of saveDataConversion) {
      if (item.isYes === "" || item.isYes === null) {
        alert("All questions need to be answered", "Alert");
        postUserLog({
          event: "Survey Alert Message",
          data: {
            action: `Ok Clicked for "All questions need to be answered" pop up`,
            module: "Digital Tier",
            section: props.navigationOn,
            siteUId: siteId,
            widget: "Survey App",
            tierId: tierId,
          },
        });
        return;
      }
      if (
        item.isYes !== null &&
        !item.isYes &&
        (item.comments === "" || item.comments === null)
      ) {
        alert("Please provide comments for questions answered 'No'", "Alert");
        postUserLog({
          event: "Survey Alert Message",
          data: {
            action: `Ok Clicked for "Please provide comments for questions answered 'No'" pop up`,
            module: "Digital Tier",
            section: props.navigationOn,
            siteUId: siteId,
            widget: "Survey App",
            tierId: tierId,
          },
        });
        return;
      }
    }
    const saveObj = {
      surveyID: surveyIDVal,
      tierID: +tierId,
      shiftScheduleID: selectedShift,
      shiftDate: moment(multiSurveyDate).format("YYYY-MM-DD"),
      surveyShiftQuestion: saveDataConversion,
      section: props.navigationOn,
      shift: surveyShiftDetails
        .filter((data: any) => data?.shiftScheduleId === selectedShift)
        .map((filteredname: any) => `${filteredname.shiftName}`)[0],
    };

    actions.manageShiftSurveyQuestionsData(dispatch, saveObj);
    notify("Survey got saved successfully!", "success", 500);
    // close(false);
  };

  const togglePopup = () => {
    setshowPopUp(!showPopUp);
    setsurveyEditPopUpMgr(false);
  };

  const onShiftValueChange = (e: any) => {
    if (e.event !== undefined) {
      setSelectedShift(e.value);
    }
  };
  return (
    <div className="surveypopup">
      <Popup
        dragEnabled={false}
        showCloseButton={true}
        showTitle={true}
        title={surveyNameVal}
        height={700}
        visible={open}
        hideOnOutsideClick={false}
        width={980}
        onHiding={() => {
          close(false);
          postUserLog({
            event: "Survey Input Screen Exit",
            data: {
              action: "Exit Survey Input screen",
              module: "Digital Tier",
              section: props.navigationOn,
              siteUId: siteId,
              widget: "Survey App",
              tierId: tierId,
            },
          });
        }}
      >
        <Position at="center" my="center" />
        {surveyIDVal &&
          surveyShiftDetails &&
          surveyShiftDetails.length !== 0 && (
            <div>
              <div>
                <div className="flx-spc-btn">
                  {surveyShiftDetails && (
                    <div>
                      <SelectBox
                        dataSource={surveyShiftDetails}
                        valueExpr="shiftScheduleId"
                        displayExpr="shiftName"
                        placeholder="Select Shift"
                        label="Shift"
                        labelMode="floating"
                        value={selectedShift}
                        onValueChanged={onShiftValueChange}
                      />
                    </div>
                  )}
                  <div>
                    {surveyShiftDetails && (
                      <DateBox
                        label="Date"
                        labelMode="floating"
                        placeholder="Select Date"
                        type="date"
                        useMaskBehavior={true}
                        value={multiSurveyDate}
                        onValueChanged={(e: any) => {
                          setMultiSurveyDate(e.value);
                            setSiteLocalDate(e.value);
                        }}
                        min={
                          surveyShiftDetails[0]?.initialDate
                            ? new Date(surveyShiftDetails[0]?.initialDate)
                            : inputMinDate
                        }
                        max={
                          surveyShiftDetails[0]?.tierSurveyInactivatedOn &&
                          !surveyShiftDetails[0]?.siteSurveyInactivatedOn
                            ? new Date(
                                surveyShiftDetails[0]?.tierSurveyInactivatedOn
                              )
                            : surveyShiftDetails[0]?.siteSurveyInactivatedOn &&
                              !surveyShiftDetails[0]?.tierSurveyInactivatedOn
                            ? new Date(
                                surveyShiftDetails[0]?.siteSurveyInactivatedOn
                              )
                            : surveyShiftDetails[0]?.siteSurveyInactivatedOn &&
                              surveyShiftDetails[0]?.tierSurveyInactivatedOn
                            ? _.min([
                                new Date(
                                  surveyShiftDetails[0]?.siteSurveyInactivatedOn
                                ),
                                new Date(
                                  surveyShiftDetails[0]?.tierSurveyInactivatedOn
                                ),
                              ])
                            : inputMinDate
                        }
                        // max={inputMinDate}
                      />
                    )}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "baseline",
                      justifyContent: "end",
                    }}
                  >
                    <b
                      style={{
                        marginRight: "10px",
                      }}
                    >
                      Target:{" "}
                    </b>
                    <TextBox
                      readOnly={true}
                      value={surveyTarget + `%`}
                      width="25%"
                      inputAttr={{
                        id: "disabled-sch-attainment",
                      }}
                    />
                  </div>
                </div>
                <div className="flx-spc-btn" style={{ marginTop: "10px" }}>
                  <div className="dx-field" style={{ width: "38%" }}></div>
                  <div
                    className="dx-field"
                    style={{ width: "38%", marginLeft: "14px" }}
                  ></div>
                  <div style={{ width: "60%" }}>
                    {surveyShiftDetails &&
                      surveyShiftDetails.length > 0 &&
                      surveyShiftDetails.map((data: any) => (
                        <>
                          <div className="dle-sadn">
                            <div>{data.shiftName}</div>
                            <div>
                              <span
                                className="andon"
                                style={{
                                  background:
                                    data.surveyActual != null
                                      ? data.surveyActual >= data.surveyTarget
                                        ? "#48ff00"
                                        : data.surveyActual < data.surveyTarget
                                        ? "red"
                                        : "red"
                                      : "#666",
                                }}
                              >
                                {" "}
                              </span>
                            </div>
                            <div style={{ width: "60px" }}>
                              {Number(data.surveyActual).toFixed(2) + "%"}
                            </div>
                          </div>
                        </>
                      ))}
                  </div>
                </div>
              </div>
              {isCurrentDate &&
                initialQuestionare?.length >= 0 &&
                initialQuestionare[0]?.tableval[0]?.isYes === null && (
                  <div>
                    <Button onClick={saveClick} className="savesurveybutton">
                      Submit
                    </Button>
                  </div>
                )}

              <div className="surveyaccordian inputscreen">
                {" "}
                {Questionare && (
                  <>
                    <Tabs>
                      <TabList style={{ width: "83%" }}>
                        {/* {!tabArray && */}
                        {tabArray.map((item: any) => (
                          <Tab
                            style={{
                              backgroundColor:
                                newTabArrayColor[item - 1]?.Color,
                              width: 100 / tabArray.length - 4 + `%`,
                            }}
                          >
                            {item}
                          </Tab>
                        ))}
                      </TabList>
                      {tabArray &&
                        tabArray.map((item: any) => (
                          <TabPanel>
                            <Accordion
                              collapsible={true}
                              multiple={false}
                              animationDuration={300}
                              className="multiSurveyacordion"
                              style={{ margintop: "5px" }}
                            >
                              {Questionare &&
                                Questionare?.slice(
                                  (item - 1) * 3,
                                  item * 3
                                ).map((item: any, index: any) => (
                                  <AccordionItem
                                    key={index}
                                    titleRender={() => customHeader(item)}
                                  >
                                    <table className="table table-bordered">
                                      <thead>
                                        <tr>
                                          <th>Questions</th>
                                          <th>Weight</th>
                                          <th>Y/N</th>
                                          <th>Reason</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {item.tableval.map(
                                          (itemQuestion: any, index: any) => (
                                            <tr>
                                              <td className="inputquestion">
                                                {" "}
                                                {itemQuestion.question}
                                              </td>
                                              <td className="inputweight">
                                                {" "}
                                                {itemQuestion.weightage}
                                              </td>
                                              <td className="inputcheckbox">
                                                {" "}
                                                <ButtonGroup
                                                  items={yesOrNo}
                                                  keyExpr="alignment"
                                                  stylingMode="contained"
                                                  buttonTemplate="content"
                                                  selectedItemKeys={
                                                    itemQuestion.isYes
                                                  }
                                                  className="buttoncolor"
                                                  onItemClick={(v) => {
                                                    if (
                                                      v &&
                                                      v.component &&
                                                      v.event !== undefined
                                                    ) {
                                                      onIsYesChange(
                                                        v,
                                                        itemQuestion,
                                                        item
                                                      );
                                                    }
                                                  }}
                                                  disabled={
                                                    isCurrentDate &&
                                                    initialQuestionare?.length >=
                                                      0 &&
                                                    initialQuestionare[0]
                                                      ?.tableval[0]?.isYes !==
                                                      null
                                                      ? true
                                                      : !isCurrentDate
                                                      ? true
                                                      : false
                                                  }
                                                >
                                                  {" "}
                                                  <RequiredRule />
                                                </ButtonGroup>
                                              </td>
                                              <td>
                                                {" "}
                                                <TextBox
                                                  onValueChanged={(v) => {
                                                    if (
                                                      v &&
                                                      v.component &&
                                                      v.event !== undefined
                                                    ) {
                                                      onQuestionChange(
                                                        v,
                                                        itemQuestion,
                                                        item
                                                      );
                                                    }
                                                  }}
                                                  disabled={
                                                    itemQuestion.isYes ==
                                                      null ||
                                                    itemQuestion.isYes ==
                                                      true ||
                                                    (isCurrentDate &&
                                                    initialQuestionare?.length >=
                                                      0 &&
                                                    initialQuestionare[0]
                                                      ?.tableval[0]?.isYes !==
                                                      null
                                                      ? true
                                                      : !isCurrentDate
                                                      ? true
                                                      : false)
                                                  }
                                                  value={itemQuestion.comments}
                                                />
                                              </td>
                                            </tr>
                                          )
                                        )}
                                      </tbody>
                                    </table>
                                  </AccordionItem>
                                ))}
                            </Accordion>
                          </TabPanel>
                        ))}
                    </Tabs>
                  </>
                )}
                {/* <Accordion
                  collapsible={true}
                  multiple={false}
                  animationDuration={300}
                  className="multiSurveyacordion"
                  style={{ margintop: "5px" }}
                >
                  {Questionare &&
                    Questionare?.map((item: any, index: any) => (
                      <AccordionItem
                        key={index}
                        titleRender={() => customHeader(item)}
                      >
                        <table className="table table-bordered">
                          <thead>
                            <tr>
                              <th>Questions</th>
                              <th>Weight</th>
                              <th>Y/N</th>
                              <th>Reason</th>
                            </tr>
                          </thead>
                          <tbody>
                            {item.tableval.map(
                              (itemQuestion: any, index: any) => (
                                <tr>
                                  <td className="inputquestion">
                                    {" "}
                                    {itemQuestion.question}
                                  </td>
                                  <td className="inputweight">
                                    {" "}
                                    {itemQuestion.weightage}
                                  </td>
                                  <td className="inputcheckbox">
                                    {" "}
                                    <ButtonGroup
                                      items={yesOrNo}
                                      keyExpr="alignment"
                                      stylingMode="contained"
                                      buttonTemplate="content"
                                      selectedItemKeys={itemQuestion.isYes}
                                      className="buttoncolor"
                                      onItemClick={(v) => {
                                        if (
                                          v &&
                                          v.component &&
                                          v.event !== undefined
                                        ) {
                                          onIsYesChange(v, itemQuestion, item);
                                        }
                                      }}
                                      disabled={
                                        isCurrentDate &&
                                        initialQuestionare?.length >= 0 &&
                                        initialQuestionare[0]?.tableval[0]
                                          ?.isYes !== null
                                          ? true
                                          : !isCurrentDate
                                          ? true
                                          : false
                                      }
                                    >
                                      {" "}
                                      <RequiredRule />
                                    </ButtonGroup>
                                  </td>
                                  <td>
                                    {" "}
                                    <TextBox
                                      onValueChanged={(v) => {
                                        if (
                                          v &&
                                          v.component &&
                                          v.event !== undefined
                                        ) {
                                          onQuestionChange(
                                            v,
                                            itemQuestion,
                                            item
                                          );
                                        }
                                      }}
                                      disabled={
                                        itemQuestion.isYes == null ||
                                        itemQuestion.isYes == true ||
                                        (isCurrentDate &&
                                        initialQuestionare?.length >= 0 &&
                                        initialQuestionare[0]?.tableval[0]
                                          ?.isYes !== null
                                          ? true
                                          : !isCurrentDate
                                          ? true
                                          : false)
                                      }
                                      value={itemQuestion.comments}
                                    />
                                  </td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                      </AccordionItem>
                    ))}
                </Accordion> */}
              </div>
            </div>
          )}
        <div>
          {surveyShiftDetails === null && (
            <div>
              <center>
                <h2>No Survey Present</h2>
              </center>
            </div>
          )}
        </div>
        <div>
          {surveyShiftDetails && !surveyIDVal && (
            <div>
              <center>
                <h2>No Survey Present</h2>
              </center>
            </div>
          )}
        </div>
        <div>
          {!surveyShiftDetails &&
            surveyIDVal &&
            surveyShiftDetails.length === 0 && (
              <div>
                <center>
                  <h2>Kindly have Tier Owner/Alternate to set Shift details</h2>
                </center>
              </div>
            )}
        </div>
      </Popup>
    </div>
  );
};
export default MultiSurveyDailyInput;
